export class SentMailFilter {
    public utilityId: string;  
    constructor() {
        this.utilityId = null;
    }
}
